import { useState } from 'react'
import { useParams } from 'react-router-dom'
import useCustomerContacts from '../../../../services/queries/customer/useCustomerContacts'
import { Pagination } from '../../../../entities'
import {
  Card,
  Col,
  ContentBody,
  ListItem,
  Row
} from '../../../../core/components'

export const PersonalDataTab = () => {
  const { id }: any = useParams()
  const [pagination, setPagination] = useState<Pagination>({
    page: 1,
    limit: 1
  })
  const { data, error, isLoading }: any = useCustomerContacts({
    ...pagination,
    id
  })

  if (isLoading) {
    return null
  }

  if (error) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  return (
    <>
      <ContentBody>
        <Card>
          <div style={{ fontSize: '16px' }}>
            <Row gutter={24} style={{ marginBottom: 10 }}>
              <Col span={12}>
                <ListItem label="Telefone 1">{data?.data.phoneNumber}</ListItem>
                <ListItem label="Telefone 2">{data?.data.cellNumber}</ListItem>
              </Col>
              <Col span={12}>
                <ListItem label="Email">{data?.data.email}</ListItem>
                <ListItem label="Observação">{data?.data.observation}</ListItem>
              </Col>
            </Row>
          </div>
        </Card>
      </ContentBody>
    </>
  )
}
